import { defineReactiveModel, Persistable, belongsTo } from "vue-app-utils";
import Model from "@/models/model";

const Location = {
  extends: Model,
  mixins: [
    Persistable,
    belongsTo("league")
  ],
  data () {
    return {
      name: "",
      numberOfTables: 1,
      slots: []
    };
  }
};

export default defineReactiveModel(Location);
